// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1o74L","colBig":"styles_colBig__3lK2g","colSmall":"styles_colSmall__1-Y3y"};